import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['applybutton'];
  multiselectClick() {
    this.applybuttonTarget.classList.add('filter-button__active');
  }
}
